<template>
    <div v-loading="dataLoading">
        <template v-if="data">
            <el-card header="被举报人信息">
                <el-row :gutter="40">
                    <el-col :xs="24" :sm="12" :md="8"><span class="color-info">用户ID: </span>{{data.userId}}</el-col>
                    <el-col :xs="24" :sm="12" :md="8"><span class="color-info">用户名称: </span>{{data.userName}}</el-col>
                    <el-col :xs="24" :sm="12" :md="8"><span class="color-info">注册时间: </span>{{data.regTime}}</el-col>
                    <el-col :xs="24" :sm="12" :md="8"><span class="color-info">支付过演出订单: </span>{{data.orderCount}}</el-col>
                    <el-col :xs="24" :sm="12" :md="8"><span class="color-info">评论数: </span>{{data.letterCount}}</el-col>
                    <el-col :xs="24" :sm="12" :md="8"><span class="color-info">联系手机: </span>{{data.phone}}</el-col>
                </el-row>
            </el-card>
            <el-card :header="`最近被举报记录（一共${data.reportNum}条，这里最多显示最近3条）`" class="MT20">
                <el-table
                    :data="data.recentReport"
                    border
                    style="width: 100%"
                    size="small"
                    stripe
                >
                    <el-table-column prop="content" label="内容" min-width="200" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column label="图片">
                        <template slot-scope="scope">
                            <el-image v-if="scope.row.pic && scope.row.pic.length == 1" :src="scope.row.pic[0] | coverImage(120,120)" fit="cover" :preview-src-list="[scope.row.pic[0]]"></el-image>
                            <el-button v-else-if="scope.row.pic && scope.row.pic.length > 1" type="text" size="mini" @click="preiewImg(scope.row.pic)">多图</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="reportType" label="被举报类型">
                        <template slot-scope="scope">
                            {{reportType.get(scope.row.reportType)}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="createTime" label="被举报时间" min-width="150"></el-table-column>
                </el-table>
            </el-card>
            <el-card v-if="$utils.have('/report/handle')" header="举报处理" class="MT20">
                <el-form
                    :model="formData"
                    ref="formData"
                    label-position="top"
                    :disabled="data.isHandle != 1 ? true : false"
                >
                    <el-row :gutter="30">
                        <el-col :xs="24" :sm="12" :xl="8">
                            <el-form-item prop="type" label="处理类型:">
                                <el-select v-model="formData.type" placeholder="请选择处理类型" size="medium">
                                    <el-option :value="1" label="禁言"></el-option>
                                    <el-option :value="2" label="仅标记已处理"></el-option>
                                    <el-option :value="3" label="忽略"></el-option>
                                </el-select>
                            </el-form-item>   
                        </el-col>
                        <el-col v-if="formData.type==1" :xs="24" :sm="12" :xl="8">
                            <el-form-item prop="days" label="处罚力度:">
                                <el-select v-model="formData.days" placeholder="请选择处罚力度" size="medium">
                                    <el-option :value="3" label="3天"></el-option>
                                    <el-option :value="30" label="30天"></el-option>
                                    <el-option :value="90" label="90天"></el-option>
                                    <el-option :value="0" label="永久"></el-option>
                                </el-select>
                            </el-form-item>   
                        </el-col>
                    </el-row>
                    <el-form-item v-if="formData.type!=3" prop="isShieldAll" label="屏蔽用户的所有评论:">
                        <el-radio-group v-model="formData.isShieldAll" size="medium">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item  v-if="formData.type!=3" prop="remark" label="结果通知:">
                        <el-input placeholder="请输入结果通知" v-model="formData.remark" size="medium" type="textarea" :autosize="true" maxlength="100" show-word-limit></el-input>
                    </el-form-item>
                </el-form>
                <div class="MT20">
                    <el-button @click="goBack">返回</el-button>
                    <el-button
                        v-if="data.isHandle == 1"
                        type="primary"
                        @click="onSubmit"
                        :loading="btnLoading"
                        >保存</el-button
                    >
                </div>
            </el-card>
        </template>
        <div v-if="!$utils.have('/report/handle')" class="btn MT20"><el-button @click="goBack">返回</el-button></div>
        <el-dialog :visible.sync="photoListView" title="举报图片" center append-to-body>
            <div class="preview-box">
                <el-image style="width: 100px; height: 100px;margin: 10px;" v-for="(image, index) in photoList" fit="cover" :src="image | coverImage(200,200)" :preview-src-list="photoList.slice(index).concat(photoList.slice(0,index))" :key="index">
                    <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                    </div>
                </el-image>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props:{
        id: {
            type: [Number, String],
            default: () => null
        }
    },
    data(){
        return{
            dataLoading: false,
            redirect: this.$route.query.redirect || '/operation/accusation',
            data:null,
            formData:{
                days: 3,
                id: '',
                isShieldAll: 1,
                remark:'感谢您的反馈。经核实您提供的资料已采纳，被举报用户已处理，感谢您对秀动的支持！',
                type: 1,
                userId:''
            },
            btnLoading: false,
            photoList: [],
            photoListView: false,
        }
    },
    computed:{
        reportType(){
            return new Map([
                [1,'欺诈'],[2,'色情'],[3,'广告'],[4,'骚扰'],[5,'其它'],[10,'动态'],[11,'评论'],[12,'回复'],[14,'弹幕']
            ])
        }
    },
    mounted(){
        if (this.id) {
            this.getDataDetail();
        }
    },
    methods:{
        //获取详情
        getDataDetail() {
            this.dataLoading = true;
            this.$request({
                url: "/report/detail",
                params: { id: this.id },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.data = {...result};
                        if(this.data.recentReport){
                            this.data.recentReport.map(v => {
                                v.pic = v.pic ? v.pic.split(',') : ''
                            })
                        }
                    } else {
                        this.$message.error(msg || "获取详情失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取详情失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        preiewImg(list){
            this.photoList = list;
            this.photoListView = true;
        },
         //返回
        goBack() {
            if(this.redirect){
                this.$router.push({
                    path: this.redirect,
                });
            }else{
                this.$router.go(-1);
            }
        },
        //表单提交
        onSubmit() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.$request({
                        url: '/report/handle',
                        method: "POST",
                        data: {...this.formData,id: this.id,userId: this.data.userId},
                    })
                        .then((res) => {
                            //处理成功回调
                            const { state, msg } = res.data;
                            if (state && state == 1) {
                                this.$confirm('是否返回列表', '操作成功', {
                                    type: 'success',
                                    center: true,
                                    confirmButtonText:'返回列表',
                                    cancelButtonText:'留在当前页面',
                                    closeOnClickModal: false
                                }).then(() => {
                                    this.goBack();
                                }).catch(() => {
                                    this.getDataDetail();
                                })
                            } else {
                                return this.$message.error(msg || "操作失败");
                            }
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            });
        },
    }
}
</script>

<style lang="scss" scoped>
.el-card{
    .el-col{
        line-height: 36px;
    }
}
</style>